import { Box, Grid, Stack } from '@mui/material';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import { CircularBackdrop } from '../components/common/circularBackdrop/circularBackdrop';
import { ReturnEquipmentContent } from '../components/detailContent/buttonActions/returnEquipmentContent';
import { Footer } from '../components/footer/footer';
import { Header } from '../components/header/header';

const ReturnEquipmentRoute = () => {
  const params = useParams();
  return (
    <Suspense fallback={<CircularBackdrop />}>
      <Stack
        minHeight="100vh"
        width="100%"
        direction="column"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={0}
      >
        <Header />
        <Box
          sx={{
            width: '100%',
            minHeight: '80vh',
            backgroundColor: 'rgb(241,241,241)',
          }}
        >
          <Stack
            sx={{
              alignItems: 'center',
              paddingTop: '2em',
              paddingBottom: '1em',
            }}
          >
            <Grid
              container
              sx={{
                maxWidth: '1200px',
                alignItems: 'center',
              }}
            >
              <ReturnEquipmentContent
                contractNumber={String(params.contractNumber)}
                contractPosition={String(params.contractPosition)}
              />
            </Grid>
          </Stack>
        </Box>
        <Footer />
      </Stack>
    </Suspense>
  );
};

export default ReturnEquipmentRoute;
